import { Card, Button } from "react-bootstrap";
import AlertMessage from "../../../Alert";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CadastroContext } from "../../../../contexts/CadastroContext";
import './style.css';

const AsoRazaoSocial = () => {
    const navigate = useNavigate();
    const [isDisabled, setIsDisabled] = useState(true);
    const [razaoSocial, setRazaoSocial] = useState('');
    const [alert, setAlert] = useState({ show: false, message: "", variant: "success" });
    const { cadastro, handleCadastroChange } = useContext(CadastroContext);

    const handleRazaoSocial = (event: any) => {
        const value = event.target.value.toUpperCase();
        if (value) {
            setRazaoSocial(value);
            cadastro.razaoSocial = value;
            handleCadastroChange(cadastro);
            setIsDisabled(false);
        }
    }

    const handleVoltar = () => {
        navigate('/aso/registro/validar-cnpj');
    }

    const handleContinuar = () => {
        if (razaoSocial) {
            navigate('/aso/registro/cnae');
        }
    }

    return(
        <>
            <div className="aso-container-razao-social">
                <div className="aso-titulo-container-razao-social">
                <div className="aso-titulo-razao-social">
                    Qual é a Razão Social da Empresa?
                </div>
                </div>
                <div className="aso-container-card-razao-social">
                <Card className="aso-card-razao-social">
                    <div className="aso-card-content-container-razao-social">
                    <div className="aso-inputs-row">
                        <div className="aso-card-content-razao-social">
                        <label htmlFor="razao-social" className="label-container">
                            <span className="aso-card-content-razao-social-label-span">Razão Social</span>
                        </label>
                        <div className="aso-card-content-container-razao-social-input">
                            <input
                            type="text"
                            id="razao-social"
                            title="Digite a Razão Social"
                            placeholder="Digite a razão social"
                            className="aso-card-content-razao-social-input"
                            onChange={(e: any) => handleRazaoSocial(e)}
                            />
                        </div>
                        </div>
                    </div>
                    </div>
                </Card>
                <div className="aso-button-razao-social-container">
                    <Button
                        variant="primary"
                        className="aso-button-razao-social-content"
                        onClick={handleVoltar}
                    >
                    Voltar
                    </Button>
                    <Button
                        variant="primary"
                        className="aso-button-razao-social-content"
                        onClick={handleContinuar}
                        disabled={isDisabled}
                    >
                    Continuar
                    </Button>
                </div>
                </div>
            </div>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </>
    );
}

export default AsoRazaoSocial;